import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import PrescriptionsListBody from "components/ClinicalManagement/Prescriptions/PrescriptionsListBody";

const Prescriptions = () => {
  useEffect(() => {
    document.title = "Prescriptions";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <PrescriptionsListBody />
    </main>
  );
};

export default Prescriptions;
